export default "__VITE_ASSET__CZ98RM3K__"